// extracted by mini-css-extract-plugin
export default {"root":"Search_root__DjA4t","input":"Search_input__CDvJ2","icon":"Search_icon__lVF3d","clearIcon":"Search_clearIcon__t5YHp"};